import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { SnackbarService } from '@/services/snackbar/snackbar.service';

@Component({
  selector: '.view-snackbar',
  imports: [
  ],
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class SnackbarComponent {
  readonly snackbarService = inject(SnackbarService);
}
